module.exports = __webpack_public_path__ + "img/api-3.020388fe.png";